import { render } from "./ResultsPopup.vue?vue&type=template&id=77aa37c4&scoped=true"
import script from "./ResultsPopup.vue?vue&type=script&lang=js"
export * from "./ResultsPopup.vue?vue&type=script&lang=js"

import "./ResultsPopup.vue?vue&type=style&index=0&id=77aa37c4&scoped=true&lang=css"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77aa37c4"]])

export default __exports__